import { useSyncExternalStore } from 'react';
import { Toast } from './Toast';
import type { ToastProps } from './Toast.types';
import { toastStore } from './toastStore';

export const ToastContainer = (props: ToastProps) => {
  const toasts = useSyncExternalStore(
    toastStore.subscribe,
    toastStore.getSnapshot,
    toastStore.getSnapshot,
  );

  return (
    <>
      {toasts.map((toast) => {
        return <Toast id={toast.id} key={toast.id} {...props} {...toast} />;
      })}
    </>
  );
};
